// App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Home from './components/Home';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Pricing from './components/Pricing';
import ProtectedRoute from './components/ProtectedRoute';
import CompleteSignup from './components/CompleteSignup';
import ResetPassword from './components/ResetPassword';
import VerifyEmail from './components/VerifyEmail';
import SubscriptionSuccess from './components/SubscriptionSuccess';
import Contact from './components/Contact';
import Privacy from './components/Privacy';
import Terms from './components/Terms';
import NotFound from './components/NotFound';
import './styles/main.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* React app routes */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/complete-signup" element={<CompleteSignup />} />
          <Route path="/subscription/success" element={<SubscriptionSuccess />} />
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />

          {/* 404 for unknown routes */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
